import setPageMetadata, { Metadata } from "@DSG/Overrides/Common/Utilities/setPageMetadata";

import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LookUpData,
    SetMetadata
} from "@insite/client-framework/Store/CommonHandlers/SetMetadata";

type TrackingParameters = Parameters<typeof LookUpData>[0];

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
replaceInChain(chain, SetMetadata, SetMetadataExt);

function SetMetadataExt(props: TrackingParameters) {
    if (props.metadata) {
        setPageMetadata(props.metadata, props.websiteSettings, props.website);
    }
};


